/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CreateOperationConversation200Response } from '../models';
// @ts-ignore
import type { OperationConversationCreateDTO } from '../models';
/**
 * NexusOperationConversationApi - axios parameter creator
 */
export const NexusOperationConversationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a conversation for an operation you are part of
         * @summary Create a conversation for an operation
         * @param {string} operationId 
         * @param {OperationConversationCreateDTO} operationConversationCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperationConversation: async (operationId: string, operationConversationCreateDTO: OperationConversationCreateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('createOperationConversation', 'operationId', operationId)
            // verify required parameter 'operationConversationCreateDTO' is not null or undefined
            assertParamExists('createOperationConversation', 'operationConversationCreateDTO', operationConversationCreateDTO)
            const localVarPath = `/api/nora/nexus/operation/{operationId}/conversation`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operationConversationCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NexusOperationConversationApi - functional programming interface
 */
export const NexusOperationConversationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NexusOperationConversationApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a conversation for an operation you are part of
         * @summary Create a conversation for an operation
         * @param {string} operationId 
         * @param {OperationConversationCreateDTO} operationConversationCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOperationConversation(operationId: string, operationConversationCreateDTO: OperationConversationCreateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateOperationConversation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOperationConversation(operationId, operationConversationCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationConversationApi.createOperationConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NexusOperationConversationApi - factory interface
 */
export const NexusOperationConversationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NexusOperationConversationApiFp(configuration)
    return {
        /**
         * Create a conversation for an operation you are part of
         * @summary Create a conversation for an operation
         * @param {NexusOperationConversationApiCreateOperationConversationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperationConversation(requestParameters: NexusOperationConversationApiCreateOperationConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateOperationConversation200Response> {
            return localVarFp.createOperationConversation(requestParameters.operationId, requestParameters.operationConversationCreateDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createOperationConversation operation in NexusOperationConversationApi.
 */
export interface NexusOperationConversationApiCreateOperationConversationRequest {
    readonly operationId: string

    readonly operationConversationCreateDTO: OperationConversationCreateDTO
}

/**
 * NexusOperationConversationApi - object-oriented interface
 */
export class NexusOperationConversationApi extends BaseAPI {
    /**
     * Create a conversation for an operation you are part of
     * @summary Create a conversation for an operation
     * @param {NexusOperationConversationApiCreateOperationConversationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOperationConversation(requestParameters: NexusOperationConversationApiCreateOperationConversationRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationConversationApiFp(this.configuration).createOperationConversation(requestParameters.operationId, requestParameters.operationConversationCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

